import React from "react";

import OnboardingTagSelectionScreen from "./Components/OnboardingTagSelectionScreen";

import type { AppUserSession } from "@/schemas/auth/session";
import { UserAttributeType } from "@/schemas/profile/UserAttributeSet";

type Props = {
  session: AppUserSession;
};

function OnboardingLanguageScreen({ session }: Props): React.JSX.Element {
  return (
    <OnboardingTagSelectionScreen
      session={session}
      userAttributeType={UserAttributeType.LANGUAGES}
      title="What language(s) do you speak?"
      description="Our community is global. Add your languages to find and be found by others who speak your tongue, and open the door to connections you might have otherwise missed."
    />
  );
}

export default OnboardingLanguageScreen;
